export const animationToGambleTime = 0.3
export const animationSliderMouseDown = 0.2
export const animationSliderTrackClick = 0.3
export const animationSliderMouseMove = 0.1
